import React from 'react';
import ReactECharts from 'echarts-for-react';

const StatusRing = ({ data, title }) => {
  const option = {
    backgroundColor: 'transparent',
    title: {
      text: title,
      left: 'center',
      top: 'center',
      textStyle: {
        color: '#F8FAFC',
        fontSize: 16,
        fontWeight: 'normal',
      }
    },
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        name: 'Compliance Status',
        type: 'pie',
        radius: ['60%', '80%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderColor: '#0B1120',
          borderWidth: 2
        },
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '18',
            fontWeight: 'bold',
            color: '#F59E0B'
          }
        },
        labelLine: {
          show: false
        },
        data: data
      }
    ]
  };

  return <ReactECharts option={option} style={{ height: '250px', width: '100%' }} />;
};

export default StatusRing;